module.exports = __webpack_public_path__ + "static/media/Interstate-Regular.77b3a374.otf";